import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import _ from "lodash";

class Nav extends Component {
  navList = () => {
    const { classCodes, history } = this.props;
    const { params, pathname } = this.props.location;
    const { cCode } = params;

    if (!classCodes || _.isEmpty(classCodes)) return false;

    return (
      <div className="d-flex">
        {classCodes.sort().map((code, idx) => (
          <div
            key={idx}
            className={`mr-3 pointer badge badge-${
              code === cCode ? "primary" : "secondary"
            }`}
            onClick={() => {
              history.push(`${pathname}?cCode=${code}`);
            }}
          >
            {code}
          </div>
        ))}
      </div>
    );
  };

  render() {
    return this.navList();
  }
}

const mapStateToProps = state => ({
  classCodes: state.classCodes,
  location: state.location
});

export default withRouter(connect(mapStateToProps)(Nav));
